export default "__VITE_ASSET__DvYJeFGc__"